import { useSelector } from "react-redux"
import { queryClient as qc } from 'keys'
import { getMethodsFetch } from "store/middlewares/affiliation.crud"
import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"

const useFormFields = () => {
    const { groups } = useSelector(state => state.affiliation)

    const methodOptions = useQuery({
        queryKey: [qc.methods],
        queryFn: async () => {
            const { data } = await getMethodsFetch()
            return data
        },
        refetchOnWindowFocus: false
    })

    const fields = useMemo(
        () => [
            {
                name: 'name',
                component: "input",
                placeholder: "שם",
                className: "b-name",
                mandatory: true
            },
            {
                name: 'group',
                component: "autoComplete",
                placeholder: "קבוצה",
                options: groups,
                className: "b-group",
                mandatory: true
            },
            {
                name: 'method',
                component: "autoComplete",
                placeholder: "שיטה",
                className: "b-method",
                options: methodOptions?.data,
                mandatory: true
            },
            {
                name: 'contact_first_name',
                component: "input",
                placeholder: "שם פרטי איש קשר",
                className: "b-contact_first_name"
            },
            {
                name: 'contact_last_name',
                component: "input",
                placeholder: "שם משפחה איש קשר",
                className: "b-contact_last_name"
            },
            {
                name: 'contact_phone',
                component: "input",
                placeholder: "טלפון איש קשר",
                className: "b-contact_phone"
            }
        ], []
    )

    return fields
}

export default useFormFields